// import playerStats from './playerStats';
// import teamStats from './teamStats';
import fullscreen from './fullscreen';
import titleBar from './titleBar';
import l3Matchup from './l3Matchup';
import l3Two from './l3Two';
import l3Player from './l3Player';
import sideSlab from './sideSlab';
import ticker from './ticker';
import bug from './bug';

export default {
  // playerStats,
  // teamStats,
  fullscreen,
  titleBar,
  l3Matchup,
  l3Two,
  l3Player,
  sideSlab,
  ticker,
  bug,
};
